import CompanyDetail from './CompanyDetail'
export default CompanyDetail
